import { TYPE_BUY } from 'Component/__deprecated__/StockActionV2/constants';

export const CLICK_BUY_SELL = 'CLICK_BUY_SELL';
export const SELECT_STOCK = 'SELECT_STOCK';
export const RESET_STATE = 'RESET_STATE';

export const INITIAL_STATE = {
  initPrice: 0,
  selectedCode: '',
  typeOrder: TYPE_BUY,
};

export default (state, action) => {
  const { type, payload = null } = action;

  switch (type) {
    case CLICK_BUY_SELL:
      return {
        ...state,
        typeOrder: payload.type,
        selectedCode: payload.code,
        initPrice: payload.price,
      };
    case SELECT_STOCK:
      return { ...state, selectedCode: payload, initPrice: 0 };
    case RESET_STATE:
    default:
      return { ...INITIAL_STATE, selectedCode: '' };
  }
};
